import api from '@/utils/api'

export default {
    getCabins(page, size, query, sort) {
        let filter = null
        Object.keys(query).forEach(key => {
            if (!query[key]) {
                delete query[key]
            }
        })
        if (Object.keys(query).length > 0) {
            filter = query
        }
        let range = '?range=' + encodeURIComponent(`[${page - 1},${size}]`)
        return api.get(`cabins` + (page ? range : '') + (filter ? `&filter=${encodeURIComponent(JSON.stringify(filter))}` : '') + (sort ? `&sort=${encodeURIComponent(sort)}` : ''))
    },

    getCabin(id) {
        return api.get(`cabins/${id}`)
    },

    import(clientId, formData) {
        return api.uploadFile(`cabins/import/client/${clientId}`, formData)
    }
}
